/**
 * Strip markdown syntax from text for clean TTS output.
 * Code blocks are replaced with "(code block)" since they shouldn't be read aloud.
 */
export function stripMarkdown(text: string): string {
  return text
    // Remove code blocks entirely
    .replace(/```[\s\S]*?```/g, ' (code block) ')
    // Remove inline code — keep the text inside
    .replace(/`([^`]+)`/g, '$1')
    // Remove header markers
    .replace(/^#{1,6}\s+/gm, '')
    // Remove bold/italic markers
    .replace(/\*{1,3}([^*]+)\*{1,3}/g, '$1')
    .replace(/_{1,3}([^_]+)_{1,3}/g, '$1')
    // Remove strikethrough
    .replace(/~~([^~]+)~~/g, '$1')
    // Remove link syntax, keep text
    .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1')
    // Remove images
    .replace(/!\[([^\]]*)\]\([^)]+\)/g, '$1')
    // Remove horizontal rules
    .replace(/^[-*_]{3,}$/gm, '')
    // Remove HTML tags
    .replace(/<[^>]+>/g, '')
    // Remove ANSI escape codes
    .replace(/\x1b\[[0-9;]*m/g, '')
    // Remove table formatting pipes
    .replace(/\|/g, ',')
    // Remove table separator rows
    .replace(/^[-:|]+$/gm, '')
    // Collapse multiple spaces/newlines
    .replace(/[ \t]+/g, ' ')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}
